// UXGenie Constants

export const API_CONFIG = {
  PORTKEY_VIRTUAL_KEY: 'oa-circuitry-gemini-2-flash-thinking-exp',
  MODEL_NAME: 'gemini-2.0-flash-thinking-exp-1219',
  MAX_TOKENS: 8096,
  TEMPERATURE: 0.7,
} as const;

export const MOCK_RESPONSE_DATA = {
  "claim_close_date": null,
  "product": {
    "product_base_model": null,
    "product_in_service_date": "2022-06-30T00:00:00",
    "product_id": "KNDNB4H31N6131660",
    "product_in_service_mileage": null,
    "product_model_varient": "CAR",
    "product_manufactured_date": "2022-06-30T00:00:00",
    "actor_id": null,
    "product_name": "KIA",
    "product_model": "Carnival LX",
    "product_serial_no": "KNDNB4H31N6131660"
  },
  "claim_status": "Authorized",
  "claim_id": null,
  // ... (truncated for brevity, include full mock data in production)
} as const;

export const UI_CONFIG = {
  MODAL: {
    WIDTH: 320,
    MAX_HEIGHT: 200,
    ANIMATION_DURATION: 200,
  },
  COMMENTS_PANEL: {
    MAX_HEIGHT: 160,
  },
  PREVIEW: {
    MAX_HEIGHT: 600,
    CARD_MAX_WIDTH: '95%',
  },
} as const;

export const MESSAGES = {
  EDIT_MODE: {
    WELCOME_TITLE: 'Edit Mode Active',
    PREVIEW_TITLE: 'Template Preview',
    DATA_INDICATOR: 'Showing original data',
    INSTRUCTION: 'This template is displayed with the original data below. You can provide instructions to modify specific elements or the entire template.',
  },
  VIEW_MODE: {
    TITLE: 'Template Loaded',
  },
  ERRORS: {
    NO_CODE: 'No code to save',
    NO_WORKER: 'No aiworker_id found',
    SAVE_FAILED: 'Failed to save template',
    INVALID_RESPONSE: 'Invalid response format from Portkey',
  },
  SUCCESS: {
    TEMPLATE_SAVED: 'Template saved successfully!',
  },
} as const;

export const PLACEHOLDERS = {
  CHAT_INPUT: "Type your instructions... (e.g. 'Create a 3-column layout for product info')",
  COMMENT_INPUT: "E.g., Change color to blue, make text larger, etc.",
  MODIFY_INPUT: "E.g., Make this text bold...",
} as const;

export const ROUTES = {
  UXGENIE_BASE: '/uxgenie',
  UXGENIE_HISTORY: (aiworkerId: string) => `/uxgenie/${aiworkerId}`,
  UXGENIE_CREATE: (aiworkerId: string) => `/uxgenie/${aiworkerId}/new`,
  UXGENIE_EDIT: (aiworkerId: string, usageId: string) => `/uxgenie/${aiworkerId}/edit/${usageId}`,
  UXGENIE_VIEW: (usageId: string) => `/uxgenie/view/${usageId}`,
} as const;
